import * as types from '../actions/types';

const initialState = {
  schema: null,
  years: null,
  scy: null,
  period: null,
  minMaxRating: null,
  loading: false,
  info: null,
  photo: null
};

export default function radar(state = initialState, action) {
  switch (action.type) {
    case types.GET_SCHEMA_ST:
      return {
        ...state,
        schema: action.payload,
    };
    case types.GET_YEARS_ST:
        return {
        ...state,
        years: action.payload,
    };
    case types.GET_SCY_ST:
        return {
        ...state,
        scy: action.payload,
    };
    case types.GET_PERIOD_ST:
        return {
        ...state,
        period: action.payload,
    };
    case types.MIN_MAX_RATING:
        return {
        ...state,
        minMaxRating: action.payload,
    };
    case types.MIN_MAX_RATING_LOADING:
        return {
        ...state,
        loading: action.payload,
    };
    case types.GET_INFO_ST:
        return {
        ...state,
        info: action.payload,
    };
    case types.PHOTO_ST:
        return {
        ...state,
        photo: action.payload,
    };
        default:
        return state;
    }
}
